module.exports = __webpack_public_path__ + "img/order-step1-b.3bca67e9.png";